import { render, staticRenderFns } from "./GamePlayerJoined.vue?vue&type=template&id=87c97292&scoped=true&"
import script from "./GamePlayerJoined.vue?vue&type=script&lang=js&"
export * from "./GamePlayerJoined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c97292",
  null
  
)

export default component.exports